import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import bookimg from "../Assets/image 72.png";
import icon from "../Assets/people-svgrepo-com 1.png";
import Location from "./Location.jsx";
import { Helmet } from "react-helmet";
import axios from "axios";
import { API_URI } from "../Common/data";

function BookNow() {
  const [seo, setSeo] = useState({
    title: 'Cine Celebrate - Book Now',
    metaDescription: '',
    metaKeywords: '',
    canonical: '',
    ogImage: '',
    ogTitle: '',
    ogDescription: '',
    canonicalUrl: ""
  });

  useEffect(() => {
    axios.get(`${API_URI}/page-seo/book-now`).then(res => {
      if (res.data && res.data.data) setSeo(res.data.data);
    });
  }, []);
  return (
    <>
      <Helmet>
        <title>
          {seo.metaTitle && seo.metaTitle.toLowerCase() !== "test title"
            ? seo.metaTitle
            : "Cine Celebrate - Book Now"}
        </title>
        <meta name="title" content={seo.metaTitle && seo.metaTitle.toLowerCase() !== "test title"
          ? seo.metaTitle
          : "Cine Celebrate - Book Now"} />
        <meta
          name="description"
          content={
            seo.metaDescription && seo.metaDescription.toLowerCase() !== "test description"
              ? seo.metaDescription
              : "Cine Celebrate - Book Now"
          }
        />
        <meta
          name="keywords"
          content={seo?.metaKeywords && Array.isArray(seo?.metaKeywords) ? seo?.metaKeywords.join(", ") : "Private Theater, Celebration, Cine Celebrate"}
        />
        <link rel="canonical" href={seo?.canonicalUrl} />
        <meta property="og:title" content={seo?.ogTitle} />
        <meta property="og:description" content={seo?.ogDescription} />
        <meta property="og:image" content={seo?.ogImage} />
      </Helmet>
      <Navbar />
      <div className="news-banner news-banner4">
        <p>Book Now</p>
        <br />
        <h1>Book Now</h1>
      </div>
      {/* <br />
      <br />
      <h2 className="Theaters">9 Theaters in Karol Bagh</h2>
      <br />
      <br />
      <div className="book-cards">
        <div className="book-card">
          <img className="book-card-img" src={bookimg} />
          <div className="book-text">
            <div className="book-heading">
              <h4>Majestic Theater </h4>
              <p>Available Slot</p>
            </div>
            <div className="book-location">
              <p>
                <i class="bi bi-geo-alt-fill"></i>Karol Bagh
              </p>
            </div>
            <div className="book-people">
              <p>
                <img src={icon} />
                Max 10 People
              </p>
              <p>
                <img src={icon} />
                Max 10 People
              </p>

              <p>
                <img src={icon} />
                Max 10 People
              </p>
            </div>
            <div className="book-time">
              <div className="book-p">
                <p>10:00 AM to 01:00 PM</p>
              </div>
              <div className="book-p">
                <p>10:00 AM to 01:00 PM</p>
              </div>
            </div>
            <div className="book-price">
              <h3>
                Rs2399 <span>For Upto 4 People</span>
              </h3>
              <button>Book Now</button>
            </div>
          </div>
        </div>
        <div className="book-card">
          <img className="book-card-img" src={bookimg} />
          <div className="book-text">
            <div className="book-heading">
              <h4>Majestic Theater </h4>
              <p>Available Slot</p>
            </div>
            <div className="book-location">
              <p>
                <i class="bi bi-geo-alt-fill"></i>Karol Bagh
              </p>
            </div>
            <div className="book-people">
              <p>
                <img src={icon} />
                Max 10 People
              </p>
              <p>
                <img src={icon} />
                Max 10 People
              </p>

              <p>
                <img src={icon} />
                Max 10 People
              </p>
            </div>
            <div className="book-time">
              <div className="book-p">
                <p>10:00 AM to 01:00 PM</p>
              </div>
              <div className="book-p">
                <p>10:00 AM to 01:00 PM</p>
              </div>
            </div>
            <div className="book-price">
              <h3>
                Rs2399 <span>For Upto 4 People</span>
              </h3>
              <button>Book Now</button>
            </div>
          </div>
        </div>
        <div className="book-card">
          <img className="book-card-img" src={bookimg} />
          <div className="book-text">
            <div className="book-heading">
              <h4>Majestic Theater </h4>
              <p>Available Slot</p>
            </div>
            <div className="book-location">
              <p>
                <i class="bi bi-geo-alt-fill"></i>Karol Bagh
              </p>
            </div>
            <div className="book-people">
              <p>
                <img src={icon} />
                Max 10 People
              </p>
              <p>
                <img src={icon} />
                Max 10 People
              </p>

              <p>
                <img src={icon} />
                Max 10 People
              </p>
            </div>
            <div className="book-time">
              <div className="book-p">
                <p>10:00 AM to 01:00 PM</p>
              </div>
              <div className="book-p">
                <p>10:00 AM to 01:00 PM</p>
              </div>
            </div>
            <div className="book-price">
              <h3>
                Rs2399 <span>For Upto 4 People</span>
              </h3>
              <button>Book Now</button>
            </div>
          </div>
        </div>
        <div className="book-card">
          <img className="book-card-img" src={bookimg} />
          <div className="book-text">
            <div className="book-heading">
              <h4>Majestic Theater </h4>
              <p>Available Slot</p>
            </div>
            <div className="book-location">
              <p>
                <i class="bi bi-geo-alt-fill"></i>Karol Bagh
              </p>
            </div>
            <div className="book-people">
              <p>
                <img src={icon} />
                Max 10 People
              </p>
              <p>
                <img src={icon} />
                Max 10 People
              </p>

              <p>
                <img src={icon} />
                Max 10 People
              </p>
            </div>
            <div className="book-time">
              <div className="book-p">
                <p>10:00 AM to 01:00 PM</p>
              </div>
              <div className="book-p">
                <p>10:00 AM to 01:00 PM</p>
              </div>
            </div>
            <div className="book-price">
              <h3>
                Rs2399 <span>For Upto 4 People</span>
              </h3>
              <button>Book Now</button>
            </div>
          </div>
        </div>
        <div className="book-card">
          <img className="book-card-img" src={bookimg} />
          <div className="book-text">
            <div className="book-heading">
              <h4>Majestic Theater </h4>
              <p>Available Slot</p>
            </div>
            <div className="book-location">
              <p>
                <i class="bi bi-geo-alt-fill"></i>Karol Bagh
              </p>
            </div>
            <div className="book-people">
              <p>
                <img src={icon} />
                Max 10 People
              </p>
              <p>
                <img src={icon} />
                Max 10 People
              </p>

              <p>
                <img src={icon} />
                Max 10 People
              </p>
            </div>
            <div className="book-time">
              <div className="book-p">
                <p>10:00 AM to 01:00 PM</p>
              </div>
              <div className="book-p">
                <p>10:00 AM to 01:00 PM</p>
              </div>
            </div>
            <div className="book-price">
              <h3>
                Rs2399 <span>For Upto 4 People</span>
              </h3>
              <button>Book Now</button>
            </div>
          </div>
        </div>
        <div className="book-card">
          <img className="book-card-img" src={bookimg} />
          <div className="book-text">
            <div className="book-heading">
              <h4>Majestic Theater </h4>
              <p>Available Slot</p>
            </div>
            <div className="book-location">
              <p>
                <i class="bi bi-geo-alt-fill"></i>Karol Bagh
              </p>
            </div>
            <div className="book-people">
              <p>
                <img src={icon} />
                Max 10 People
              </p>
              <p>
                <img src={icon} />
                Max 10 People
              </p>

              <p>
                <img src={icon} />
                Max 10 People
              </p>
            </div>
            <div className="book-time">
              <div className="book-p">
                <p>10:00 AM to 01:00 PM</p>
              </div>
              <div className="book-p">
                <p>10:00 AM to 01:00 PM</p>
              </div>
            </div>
            <div className="book-price">
              <h3>
                Rs2399 <span>For Upto 4 People</span>
              </h3>
              <button>Book Now</button>
            </div>
          </div>
        </div>
      </div> */}
      <Location />
      <Footer />
    </>
  );
}

export default BookNow;
